import { useEffect, useState } from "react";
import { useGlobalContext } from "../GlobalContext";

const ProsesHariraya = () => {
  const tglSekarang = new Date().toISOString().split("T")[0];
  const { periode, api } = useGlobalContext();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [statusDiproses, setStatusDiproses] = useState(false);

  const [formData, setFormData] = useState({
    noTransaksi: "",
    tglTransak: tglSekarang,
    noAnggota: "",
    nama: "",
    unitkerja: "",
    saldoAwl: 0,
    jenisTransaksi: "1",
    jumlah: 0,
    saldoAkhir: 0,
  });

  useEffect(() => {
    const cekStatus = async () => {
      try {
        const response = await api.get(`/api/proses/statusjasahariraya/${periode}`);
        setStatusDiproses(response.data.phariraya === true || response.data.phariraya === '1');
      } catch (error) {
        console.error("Error Cek Status Jasa Hari Raya:", error);
      }
    };
    if (periode) {
      cekStatus();
    }
  }, [periode, api]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const getAnggota = async () => {
    try {
      const response = await api.get(`/api/anggota/anggotahariraya`);
      return response.data.data || [];
    } catch (error) {
      console.error("Error Ambil Data Anggota Hariraya:", error);
      return [];
    }
  };

  const getSaldoHariraya = async () => {
    try {
      const response = await api.get(`/api/master/saldohariraya/${periode}`);
      return response.data || [];
    } catch (error) {
      console.error("Error Ambil Data Saldo Simp Hariraya:", error);
      return [];
    }
  };

  const GetNoTransaksiHariraya = async (noawal) => {
    let notransaksi = "";
    try {
      const response = await api.get(`/api/transaksi/getnotransaksihariraya/${noawal}`);
      if (response.status === 200 && response.data.notransaksi) {
        const noindextransnext = parseInt(response.data.notransaksi.toString().substring(5, 10)) + 1;
        notransaksi = noawal + noindextransnext.toString().padStart(6, "0");
      }
    } catch (error) {
      notransaksi = noawal + "000001";
    }
    return notransaksi;
  };

  const handleProses = async () => {
    const mjasa36 = 0.05 / 100;    
    const noawal = periode.toString();
    const notransaksiwal = noawal.substring(2, 6);
    const notransaksi = await GetNoTransaksiHariraya(notransaksiwal);
    const date = new Date(formData.tglTransak);
    const yyyymm = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, "0")}`;
    let indexnotransaksi = parseInt(notransaksi.substring(5, 10));

    if (statusDiproses) {
      alert(`Proses Jasa Hari Raya periode ${periode} sudah dilakukan, tidak bisa diproses kembali`);
      return;
    }

    if (yyyymm !== periode) {
      alert(`Tanggal Proses Jasa tidak sesuai dengan periode`);            
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const [datahariraya, datasldhariraya] = await Promise.all([
        getAnggota(),
        getSaldoHariraya()
      ]);

      if (!Array.isArray(datahariraya) || !Array.isArray(datasldhariraya)) {
        console.error("Data tidak valid:", datahariraya, datasldhariraya);
        alert("Data tidak valid.");
        setLoading(false);
        return;
      }

      //console.log("Data Anggota Hariraya:", datahariraya);
      //console.log("Data Saldo Simp Hariraya:", datasldhariraya);

      const recordJasaHariraya = datahariraya.map((item) => {
        const saldosimp = datasldhariraya.find(s => s.noanggota === item.noanggota) || {
          saldoawal: 0,
          saldoakh: 0
        };

        const mjasa = Math.round(mjasa36 * saldosimp.saldoakh);
        const nomorTransaksiBaru = notransaksiwal + indexnotransaksi.toString().padStart(6, '0');

        if (saldosimp.saldoakh > 0) {
          indexnotransaksi += 1;
          return {
            notransaksi: nomorTransaksiBaru,
            noanggota: item.noanggota,
            tgltransak: formData.tglTransak,
            jenissimp: 1,
            kdtrans: 3,
            saldoawl: saldosimp.saldoakh,
            debet: 0,
            kredit: mjasa,
            saldo: Number(saldosimp.saldoakh??0) + Number(mjasa??0)
          };
        } else {
          return null;
        }
      }).filter(item => item !== null);

      //console.log("Data Jasa Hariraya:", recordJasaHariraya);

      //  TUNGGU SEMUA POST SELESAI SEBELUM LANJUT
      const results = await Promise.all(
        recordJasaHariraya.map(record =>
          api.post('/api/transaksi/simpananhariraya', record)
            .then(res => {
              //console.log(" KIRIM BERHASIL:", record.notransaksi);
              return res;
            })
            .catch(error => {
              //console.error("GAGAL KIRIM:", record.notransaksi, error.response?.data || error.message);
              throw error;
            })
        )
      );

      try {
        await api.patch(`/api/proses/jasahariraya/${periode}`);
      } catch (error) {
        console.error("Gagal update status Jasa Hari Raya:", error.response?.data || error.message);
      }

      setMessage("Proses selesai & sukses. Redirect ke login...");
      
      setTimeout(() => {
        localStorage.removeItem('periode');
        window.location.href = '/login';
      }, 2000); 
      
    } catch (err) {
      console.error("Error proses:", err);
      setMessage("Gagal memproses. Lihat console untuk detail.");
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div className="card card-info" style={{ width: "325px" }}>
        <div className="card-header">
          <h3 className="card-title">Proses Jasa Hariraya</h3>
        </div>
        <div className="card-body">
          <div className="form-group row">
            <label className="col-sm-4 col-form-label text-right">Tanggal</label>
            <div className="col-sm-3">
              <input
                type="date"
                className="form-control"
                name="tglTransak"
                value={formData.tglTransak}
                onChange={handleInputChange}
                style={{ width: "150px", height: "40px" }}
              />
            </div>
          </div>
        </div>
        <div className="card-footer text-right">
          <button className="btn btn-success btn-sm" onClick={handleProses} disabled={loading || statusDiproses}>
            {loading ? "Memproses..." : "Proses"}
          </button>

          {loading && (
            <div className="text-center mt-2">
              <span className="text-info font-bold">Memproses data, harap tunggu...</span>
            </div>
          )}

          {message && (
            <div className="text-center mt-2">
              <span className="text-success font-bold">{message}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProsesHariraya;
